import { render, staticRenderFns } from "./SuppliersGroupUpdateForm.vue?vue&type=template&id=341a3b55&scoped=true&"
import script from "./SuppliersGroupUpdateForm.vue?vue&type=script&lang=js&"
export * from "./SuppliersGroupUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341a3b55",
  null
  
)

export default component.exports